import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, InputAdornment, IconButton, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../Assets/img/svg/save.svg"
import Cancel from "../../../../Assets/img/svg/cancel.svg"
import image from "../../../../Assets/img/svg/Image.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../Assets/jss/customStyle";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from "../../../../Assets/img/svg/delete.svg"
import del from "../../../../Assets/img/svg/Del.svg"
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../helpers/endpointService"
import deactive from '../../../../Assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import { VesselStatus, inspectionSystem } from "../../../Constants";
import { addshipbasicinfo, filedeleteshiplogo, addshiplogoinfo, filedeleteship, putshipbasicinfo } from "../../../../actions/AddNewShipAction";
import { getInspectionTypeList, getStatusTypeList } from "../../../../actions/Lookup"

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class AddBI extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.inputFile1 = React.createRef();
       this.state = {
            isMobile: false,
            menu: true,
            isError1: false,
            isError2: false,
            isError3: false,
            isEdit: false,
            isAccessControl: false,
            completeDateError: false,
            Logo: [],
            cancel: false,
            LogoIndex: 0,
            LogoAwsName: "",
            checkbox: true,
            ShipId: 0,
            ShipName: "",
            helperText: "",
            FileUrl: "",
            FileName: "",
            dateFormat: 'DD/MM/YYYY',
            addData: {
                "ShipId": 0,
                "ShipName": "",
                "IMONumber": "",
                "InspectionType": 0,
                "Status": "Not Started",
                "ShipPhoto":null,
                "CreatedBy": "",
                "ModifiedBy": "",
                "CreatedDate": new Date(),
                "ModifiedDate": new Date(),
                "ShipIncharge":null,
                "HistoryLogs": [],
                "Comments": "",
                "IsDeleted": false,
                 "InspectionTaskId": "",
                 "isSample" : false,
                 "isGradeApplicable" : false,
                 "IsGradeApplicable" : false,
              },
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(getInspectionTypeList(VesselStatus.InspectionType));
        dispatch(getStatusTypeList(VesselStatus.Status));
        // this.props.dispatch(getSettingsFormat(this.state.addData.ShipId))
        window.location.pathname === "/shipparticulars/add" ? this.state.isEdit = false : this.state.isEdit = true;
        localStorage.getItem("UserRoles")?.toLowerCase() == "admin" ? this.state.isAccessControl = false : this.state.isAccessControl = true;
        if (this.state.isEdit == false) {
            this.state.addData.CreatedBy = JSON.parse(localStorage.getItem("currentUser")).email;
            if (localStorage.getItem("addeditid") != null) {
                this.getshipbasicinfo(localStorage.getItem("addeditid"))
                this.state.dateFormat = 'DD/MM/YYYY';
            }
        }
        if (this.state.isEdit == true) {
            console.log(this.state.isEdit, localStorage.getItem("DashId"))
            this.state.addData.ModifiedBy = JSON.parse(localStorage.getItem("currentUser")).email;
            this.getshipbasicinfo(localStorage.getItem("DashId"))
            this.state.dateFormat = this.props.settings?.Convention ? this.props.settings?.Convention : 'DD/MM/YYYY'
        }
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
   handleCheckBoxSampleChange(e) {
      if (e.target.checked) {
          this.state.addData.isSample=true;
          this.setState({})
        } else {
            this.state.addData.isSample=false;
            this.setState({})
        }
    }
   handleCheckBoxGradeApplicableChange(e) {
      const isChecked = e.target.checked;
      this.state.addData.isGradeApplicable = isChecked;
      this.state.addData.IsGradeApplicable = isChecked;
      localStorage.setItem("IsGradeApplicable", isChecked);
      window.dispatchEvent(new Event("isGradeApplicableChanged"));
      this.setState({});
    }

    getshipbasicinfo = (data) => {
        let apiUrl = API.GET_SHIP + "/id?id=" + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    console.log(response.data)
                    this.state.ShipId = response.data?.ShipId;
                    this.state.addData.ShipId = response.data?.ShipId;
                    this.state.addData.ShipName = response.data?.ShipName;
                    this.state.addData.IMONumber = response.data?.IMONumber;
                    this.state.addData.InspectionType = parseInt(response.data?.InspectionType);
                    this.state.addData.Status = response.data?.Status;
                    this.state.addData.Comments = response.data?.Comments != null ? response.data?.Comments : "";
                    this.state.ShipName = response.data?.ShipName;
                    this.state.addData.isSample=response.data?.IsSample;
                    this.state.addData.isGradeApplicable=response.data?.IsGradeApplicable != null ? response.data?.IsGradeApplicable : false;
                    this.state.addData.IsGradeApplicable=response.data?.IsGradeApplicable != null ? response.data?.IsGradeApplicable : false;
                    this.state.addData.CreatedBy = response.data?.CreatedBy;
                    this.state.addData.ShipPhoto = response.data?.ShipPhoto;
                    if (response?.data?.ShipPhoto != null) {
                        this.state.Logo.push(response?.data?.ShipPhoto)
                        this.setState({})
                    }

                    localStorage.setItem("ShipName", response.data?.ShipName);
                    const isGrade = response.data?.IsGradeApplicable != null ? response.data?.IsGradeApplicable : false;
                    localStorage.setItem("IsGradeApplicable", isGrade);
                    window.dispatchEvent(new Event("isGradeApplicableChanged"));
                    this.setState({})
                    console.log(this.state.addData.Status)
                    console.log(this.state.addData.InspectionType)
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            });

    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#BI .MuiListItemText-primary").removeClass("fw-bolder")
        $("#BIL").removeClass("active-color")
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditship");
            }
            else {
                this.props.navigate("/sidebaraddship");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditship");
        }
        else {
            this.props.navigate("/sidebaraddship");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#BasicInformation1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#Basic1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#BasicInformation").removeClass("d-none")
        $("#BasicInformation").addClass("d-block")
        $("#BI .MuiListItemText-primary").addClass("fw-bolder")
        $("#BIL").addClass("active-color")
    };

    AttachFiles = () => {
        this.inputFile.current.click();
    };

    AttachFiles1 = () => {
        this.inputFile1.current.click();
    };

    UploadFile = (e, str) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        Array.from(e.target.files).forEach(async (a) => {
            let data = [{
                file: a,
                FileSize: a.size,
                check: false,
                FileName: a.name,
                FileUrl: await this.toBase64(a),
            }]
            this.state.Logo = data;
            this.setState({})
        })
    };

    OpenPopup = (i, str, name) => {
        if (str == "Logo") {
            this.state.LogoIndex = str;
            this.state.LogoAwsName = name;
            this.setState({})
            window.$("#deletepopuplogo").modal("show");
        }

    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    setCheckbox = (id, str) => {
        if (str == "Logo") {
            this.state.Logo.map((i, ind) => {
                if (ind == id) {
                    i.check = !i.check;
                }
            })
        }

    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/shiplist`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/shiplist`)
    };

    handleInputChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        console.log(e.target.value, node)
        if (node === "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.Comments = e.target.value;
            }
        }
        if (node === "InspectionType"){
            const val = parseInt(e.target.value);
            this.state.addData[node] = val;
            if (val === 6) {
                this.state.addData.isGradeApplicable = true;
                this.state.addData.IsGradeApplicable = true;
                localStorage.setItem("IsGradeApplicable", true);
                window.dispatchEvent(new Event("isGradeApplicableChanged"));
            } else {
                this.state.addData.isGradeApplicable = false;
                this.state.addData.IsGradeApplicable = false;
                localStorage.setItem("IsGradeApplicable", false);
                window.dispatchEvent(new Event("isGradeApplicableChanged"));
            }
        }
        else {
            this.state.addData[node] = e.target.value;
        }
        this.setState({});

    };


    Save = () => {
        const { ShipName, Status, IMONumber, InspectionType } = this.state.addData
        if (ShipName.trim() === "") {
            this.state.isError1 = true;
            this.state.addData.ShipName = this.state.addData.ShipName.trim();
            this.setState({})
        }
        else {
            this.state.isError1 = false;
            this.state.addData.ShipName = this.state.addData.ShipName.trim();
            this.setState({})
        }
        if (IMONumber === "") {
            this.state.isError2 = true;
            this.state.addData.IMONumber = this.state.addData.IMONumber.trim();
            this.setState({})
        }
        else {
            this.state.isError2 = false;
            this.state.addData.IMONumber = this.state.addData.IMONumber.trim();
            this.setState({})
        }
        if (this.state.addData.ShipName !== "" && this.state.addData.IMONumber !== "") {
            this.props.dispatch({ type: "CANCEL", data: false });
            
            if (this.state.isEdit == false) {
                let array = [];
                let formData = new FormData()
                Array.from(this.state.Logo).forEach(async (a) => {
                    formData.append("photo", a.file)
                    array.push(a);
                })
                if (localStorage.getItem("addeditid") == null) {
                    this.setState({ cancel: false })
                    this.props.dispatch(addshipbasicinfo(this.state.addData, formData, 0, array))
                }
            }
            else {
                let formData = new FormData()
                let array1 = [];
                if (this.state.Logo.length == 1) {
                    Array.from(this.state.Logo).forEach(async (a) => {
                        if (a.AwsUniqueFileName == undefined) {
                            formData.append("photo", a.file)
                            array1.push(a)
                        }
                    })
                }
                this.setState({ cancel: false })
                this.state.addData.ShipName = this.state.addData.ShipName.trim();
                if (this.state.addData.Comments != "" && this.state.addData.Comments != null) {
                    this.state.addData.Comments = this.state.addData.Comments.trim();
                }else{
                    this.state.addData.Comments = "";
                }
                this.setState({})
                this.props.dispatch(addshipbasicinfo(this.state.addData, formData, this.state.addData.ShipId, array1))
            }
        }
    };

    DeleteItemlogo = () => {
        if (this.state.LogoAwsName == undefined) {
            this.state.Logo = [];
            this.setState({})
        } else {
            this.filedeleteprojectlogo(this.state.addData.ShipId, this.state.LogoAwsName);
            this.state.Logo = [];
            this.setState({})
        }
        window.$("#deletepopuplogo").modal("hide");
    };

    filedeleteprojectlogo = (id, name) => {
        let apiUrl = API.SHIP_LOGO + id + '?uniquefilename=' + name;
          this.props.dispatch({ type: "SHOW_LOADER", data: true })
          axios({
            method: "delete",
            url: apiUrl,
            // data: data,
          })
            .then((response) => {
              this.props.dispatch({ type: "SHOW_LOADER", data: false })
              if (response?.status === 200) {
              } else {
              }
            })
            .catch((error) => {
              this.props.dispatch({ type: "SHOW_LOADER", data: false })
              if (error?.response?.status === 401) {
                // logOut();
              }
            });
      };


    OpenPopupview = (url, name) => {
        this.state.FileUrl = url;
        this.state.FileName = name;
        this.setState({})
        window.$("#viewscreen").modal("show");
    }

    render() {
        const { isError1, isError2, isError3, isError4, isEdit, addData, isAccessControl } = this.state;
        let { classes, shipStatus, menuToggle, statusType, inspectionType } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Basic" + "1"} className='textNaviIcon' primary={this.state.isEdit ? "Edit Ship" : "New Ship"} />
                                            <NavigateNextIcon id="Basic" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">Basic Information</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top " width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td className="border-right text-center" >
                                        <button className={`${classes.button}`} disabled={isAccessControl ? true : false} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Save</button>
                                    </td>
                                    <td className=" text-center">
                                        <button className={`${classes.button} `} disabled={isAccessControl ? true : false} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        :
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="5%" className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="95%">
                                            <button className={classes.button} disabled={isAccessControl ? true : false} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Save</button>
                                            <button className={`${classes.button} pl-3`} disabled={isAccessControl ? true : false} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px', opacity: isAccessControl ? "0.5" : "" }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ShipName ? this.state.ShipName : "New Ship"}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-2" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Ship Name&nbsp;:
                                        {isAccessControl ? <></> :
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div>}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isAccessControl ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled
                                            value={addData?.ShipName}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        isError1 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={addData?.ShipName}
                                                onChange={(e) => { this.handleInputChange(e, "ShipName") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                                classes={{ root: classes.helperText }}
                                            /> : <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={addData?.ShipName}
                                                onChange={(e) => { this.handleInputChange(e, "ShipName") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                            />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "d-flex m-0 text-right float-end"}>IMO Number&nbsp;:
                                        {isAccessControl ? <></> :
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div>}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isAccessControl ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled
                                            value={addData?.IMONumber}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> :
                                        isError1 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={addData?.IMONumber}
                                                onChange={(e) => { this.handleInputChange(e, "IMONumber") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                                classes={{ root: classes.helperText }}
                                            /> : <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={addData?.IMONumber}
                                                onChange={(e) => { this.handleInputChange(e, "IMONumber") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                            />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end "}>Inspection Type&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {isAccessControl ?
                                            <select
                                                fullWidth
                                                value={this.state.addData?.InspectionType}
                                                style={{ height: "40px" }}
                                                disabled
                                                className="form-control border-radius view-color"
                                            >
                                                <option value={0}>Select Inspection Type</option>
                                                {inspectionType && inspectionType?.map((item, index) => (
                                                    <option value={item.Id}>{item.Name}</option>
                                                ))}
                                            </select>
                                            : 
                                                <select
                                                    fullWidth
                                                    value={this.state.addData?.InspectionType}
                                                    style={{ height: "40px" }}
                                                    className="form-control border-radius"
                                                    onChange={(e) => { this.handleInputChange(e, "InspectionType") }}
                                                >
                                                    <option value={0}>Select Inspection Type</option>
                                                    {inspectionType && inspectionType?.map((item, index) => (
                                                        <option value={item.Id}>{item.Name}</option>
                                                    ))}
                                                </select>}
                                    </>
                                </div>
                            </div>

                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end "}>Report Status&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {isAccessControl ?
                                            <select
                                                fullWidth
                                                value={this.state.addData?.Status}
                                                disabled
                                                style={{ height: "40px" }}
                                                className="form-control border-radius view-color"
                                            >
                                                <option value="">Select Status</option>
                                                {statusType && statusType?.map((item, index) => (
                                                    <option value={item.Name}>{item.Name}</option>
                                                ))}
                                            </select>
                                            :
                                                <select
                                                    fullWidth
                                                    value={this.state.addData?.Status}
                                                    style={{ height: "40px" }}
                                                    className="form-control border-radius"
                                                    onChange={(e) => { this.handleInputChange(e, "Status") }}
                                                >
                                                    <option value="">Select Status</option>
                                                    {statusType && statusType?.map((item, index) => (
                                                        <option value={item.Name}>{item.Name}</option>
                                                    ))}
                                                </select>}
                                    </>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-6 pt-4 pb-4 d-flex align-items-center"}`}>
                                    <div className="d-flex align-items-center mr-4">
                                        <label className="m-0 mr-2">Is Sample Ship&nbsp;:</label>
                                        <input style={{ width: "20px", height: "20px" }} type="checkbox" name="isSample" checked={this.state.addData.isSample} disabled={isAccessControl?true:false} onChange={(e) => this.handleCheckBoxSampleChange(e)}></input>
                                    </div>
                                    <div className="d-flex align-items-center ml-3">
                                        <label className="m-0 mr-2">Is Grade Applicable&nbsp;:</label>
                                        <input style={{ width: "20px", height: "20px" }} type="checkbox" name="isGradeApplicable" checked={this.state.addData.isGradeApplicable} disabled={isAccessControl?true:false} onChange={(e) => this.handleCheckBoxGradeApplicableChange(e)}></input>
                                    </div>
                                </div>

                            </div>

                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 text-right float-end"}>Ship Photo&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {isAccessControl ? 
                                      <div className="row px-1">
                                      {this.state.Logo && this.state.Logo.map((i, ind) => (
                                          <div
                                            className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${
                                              window.innerWidth < 410
                                                ? "col-12"
                                                : this.state.isMobile
                                                ? "col-md-4 "
                                                : "col-md-6"
                                            }`}
                                          >
                                            <div className="row d-flex">
                                              <div
                                                className={`${
                                                  window.innerWidth < 290
                                                    ? ""
                                                    : "col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3"
                                                }`}
                                                onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)}
                                              >
                                                <img
                                                  className="cursorPointer"
                                                  width={
                                                    window.innerWidth < 290
                                                      ? "100%"
                                                      : "257px"
                                                  }
                                                  src={i.FileUrl}
                                                  onClick={() => {
                                                    this.openView1(
                                                      i.FileUrl,
                                                      i.FileName,
                                                      ind
                                                    );
                                                  }}
                                                  style={{
                                                    height: "201px",
                                                    marginTop: "-9px",
                                                    objectPosition: "50% 50%",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                    :<>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        onChange={(e) => this.UploadFile(e)}
                                        accept=".png,.jpg"
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        hidden
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile(e)}
                                        ref={this.inputFile}
                                    /></> }
                                </div>
                                {isAccessControl ? "" : 
                                <div className={`col-12 col-sm-12   col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : ""}`}>
                                    {this.state.Logo && this.state.Logo.map((i, ind) => {
                                        return (<>
                                            <div className="row align-items-center">
                                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>

                                                    <div className="ml-2">
                                                        <img src={i.FileUrl} className="cursorPointer" onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                    </div>
                                                    <div className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4">
                                                        <div onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} className="px-2 overflow cursorPointer">{i.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                    </div>
                                                    <div className="" style={{ marginTop: '-16px' }}>
                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind, "Logo", i.AwsUniqueFileName) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>)
                                    })}
                                </div>}
                            </div>
                            {isEdit ? <>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right mt-n4"}`}>
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 float-end text-right"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2  pb-1 " : "col-md-10 pt-4  pb-2 "}`}>
                                        {isAccessControl ?
                                            <TextField
                                                multiline
                                                rows={8}
                                                variant="outlined"
                                                size="small"
                                                disabled
                                                fullWidth
                                                value={this.state.addData?.Comments}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                            :
                                        <TextField
                                            multiline
                                            rows={8}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData?.Comments}
                                            onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> }
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                    </div>
                                </div>
                            </> : <></>}
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopuplogo" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#499AC8", border: "none" }} onClick={() => this.DeleteItemlogo()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopuplogo").modal("hide") }} id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div class="modal fade p-5 mt-5" id="deletepopupownerlogo" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#499AC8", border: "none" }} onClick={() => this.DeleteItemownerlogo()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopupownerlogo").modal("hide") }} data-dismiss="modal" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                    <div class="modal-dialog modal-lg " role="document">
                        <div class="modal-content ">
                            <div class="modal-body pt-0 pb-2 pr-3 pl-3 ">
                                <div className="row">
                                    <div className="col-12 ">
                                        <div className='cursorPointer float-end' id="viewscreen" onClick={() => {
                                            window.$('#viewscreen').modal('hide')

                                        }} >
                                            <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                        </div>
                                    </div>

                                    <div className='col-12 text-center'>
                                        <InnerImageZoom
                                            moveType="drag"
                                            zoomScale={2}
                                            hideCloseButton={true}
                                            src={this.state.FileUrl}
                                            hasSpacer={true}
                                            afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                            afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        alertCancel: state.commonReducer.alertCancel || [],
        statusType: state.lookupReducer.statusType || [],
        inspectionType: state.lookupReducer.inspectionType || []

    };
}

AddBI.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddBI))
);